import InformedConsentPage from "./InformedConsentPage";

export default InformedConsentPage;